<template>
    <a-card :bordered="false" class="header-solid h-full p-20" :bodyStyle="{ padding: 0 }">
        <a-page-header :title="readonly ? '查看行程' : '编辑行程'" sub-title="元素顺序可以上下自由拖动"
            @back="() => $router.history.go(-1)">
            <template slot="extra">
                <a-button type="primary" key="1" :loading="spinning" @click="getinfo">
                    刷新
                </a-button>
                <a-button type="primary" key="2" :loading="exportLoading" @click="noticeHandle">
                    通知会员行程规划已完成（新功能）
                </a-button>
                <a-button type="primary" key="3" :loading="exportLoading" @click="exportImage">
                    导出为图片
                </a-button>
                <a-button type="danger" key="4" :loading="exportLoading" @click="del"
                    v-permission="['admin:haibao:delete']">
                    删除此行程规划
                </a-button>
            </template>
            <a-descriptions :column="4">
                <a-descriptions-item label="客户名称">
                    <h5>{{ customerinfo.customer_name }}</h5>
                </a-descriptions-item>
                <a-descriptions-item label="行程单创建者">
                    <h5> {{ userinfo && userinfo.real_name ? userinfo.real_name : '会员自行创建' }}</h5>
                </a-descriptions-item>
                <a-descriptions-item label="行程单创建时间">
                    <h5> {{ create_time }}</h5>
                </a-descriptions-item>
            </a-descriptions>
            <!-- <a-row type="flex">
                <a-statistic title="客户名称" :value="customerinfo.customer_name" />
                <a-statistic title="行程单创建者" :value="userinfo.real_name" :style="{
                    margin: '0 32px',
                }" />
                <a-statistic title="行程单创建时间" prefix="" :value="customerinfo.create_time" />
            </a-row> -->
        </a-page-header>
        <a-spin tip="'保存中...'" :spinning="spinning">
            <a-checkbox-group v-model="delarr" :key="checkkey" style="width: 100%;" :disabled="readonly">
                <div class="cardContainer">
                    <div class="haibaoContainer"
                        :style="{ width: form.width + 'px', backgroundColor: form.backgroundColor }" ref="captureArea">
                        <div class="shanchu" v-if="!exportLoading">
                            <a-button :disabled="readonly" type="link"
                                @click="delarr = DataList.map(v => v.haibaoitemid)">全选</a-button>
                            <a-button :disabled="readonly" type="link" @click="delarr = []">取消勾选</a-button>
                            <a-button type="link" :disabled="delarr.length == 0 || readonly"
                                @click="delChart(delarr, true)">删除已勾选元素</a-button>
                        </div>

                        <draggable v-model="DataList" :sort="true" :disabled="readonly" @end="onEnd" key="123">
                            <div v-for="(v, i) in DataList" style="position: relative;">
                                <a-popover placement="right" trigger="click">
                                    <template slot="content" v-if="!readonly">
                                        <div>
                                            <a-button type="link" class="p-0" @click="Chart('text', i)">插入文案</a-button>
                                            <a-divider type="vertical" />
                                            <a-button type="link" class="p-0"
                                                @click="Chart('images', i)">插入图片组</a-button>
                                            <a-divider type="vertical" />
                                            <a-button type="link" class="p-0" @click="Chart('line', i)">插入分割线</a-button>
                                            <a-divider type="vertical" />
                                            <a-button type="link" class="p-0" style="color: red;"
                                                @click="delChart([v.haibaoitemid])">删除</a-button>
                                        </div>
                                        <!-- <a-input v-model="v.value" v-if="v.type == 'text'" style="width: 240px;"
                                        placeholder="请输入文案" @blur="blurText($event, i)"></a-input> -->
                                        <a-textarea v-model="v.value" v-if="v.type == 'text'"
                                            style="width: 240px;margin-bottom: 10px;" placeholder="请输入文案"
                                            @blur="blurText($event, i)" :auto-size="{ minRows: 3, maxRows: 20 }" />
                                        <div style="display: flex;align-items: center;">
                                            <span>文字颜色：</span>
                                            <el-color-picker v-model="v.textcolor"
                                                @change="blurText($event, i)"></el-color-picker>
                                        </div>
                                    </template>
                                    <template slot="content" v-else>无修改权限</template>
                                    <div class="itembox" :style="{ border: form.xuxian ? '1px dashed #CCC' : '' }">
                                        <div class="pbox" v-if="v.type == 'text'"
                                            :style="{ textAlign: form.align, color: v.textcolor }">
                                            {{ v.value !== '' ? v.value : '请输入文案' }}
                                        </div>
                                        <div v-if="v.type == 'images'">
                                            <div @paste="handlePaste($event, i)" @dragstart="handleDragStart"
                                                :contenteditable="contenteditable && !readonly"
                                                @keydown="handleKeydown">
                                                <draggable v-model="v.value" :sort="true" key="456"
                                                    :disabled="contenteditable || readonly" @end="onEnd2($event, v)"
                                                    class="imagebox"
                                                    :style="{ justifyContent: form.align == 'left' ? 'flex-start' : form.align == 'center' ? 'center' : 'flex-end' }">
                                                    <div class="imgcontainer" v-for="(imgvalue, imgindex) in v.value"
                                                        :style="{ width: form.imageWidth + 'px', height: form.imageWidth + 'px' }">
                                                        <img crossorigin alt="img" :src="imgvalue">
                                                        <div class="delimg" v-if="!exportLoading && !readonly"
                                                            @click.stop="delimg(i, imgindex)">
                                                            <a-icon type="close" />
                                                        </div>
                                                    </div>
                                                    <a-upload-dragger class="imgcontainer"
                                                        v-if="!exportLoading && contenteditable" name="file" loading
                                                        :disabled="readonly" style="height: 100%;"
                                                        :style="{ width: form.imageWidth + 'px', height: form.imageWidth + 'px' }"
                                                        :multiple="false" :showUploadList="false"
                                                        :customRequest="onDrop" :data="{ imageIndex: i }">
                                                        <p class="ant-upload-drag-icon" style="margin: 0;">
                                                            <a-icon type="inbox" />
                                                        </p>
                                                        <p class="ant-upload-hint">点击或拖拽至此上传</p>
                                                    </a-upload-dragger>
                                                </draggable>

                                                <!-- <div class="imgcontainer" v-if="!exportLoading" @dragover.prevent="onDragOver"
                                            @drop.prevent="onDrop($event, i)"
                                            :style="{ width: form.imageWidth + 'px', height: form.imageWidth + 'px' }">
                                            <a-icon type="upload" style="font-size: 24px;margin-bottom: 2px;" />
                                            <div style="font-size: 12px;color: #666;">拖拽至此上传</div>
                                        </div> -->

                                            </div>

                                        </div>
                                        <div class="line" v-if="v.type == 'line'">
                                            <div class="linevalue"></div>
                                        </div>
                                    </div>
                                </a-popover>
                                <div class="delarr" v-if="!exportLoading">
                                    <a-checkbox :value="v.haibaoitemid">
                                    </a-checkbox>
                                </div>
                            </div>
                        </draggable>

                        <a-popover placement="right" v-if="!exportLoading && !readonly">
                            <template slot="content">
                                <div>
                                    <a-button type="link" class="p-0" @click="Chart('text')">新增文案</a-button>
                                    <a-divider type="vertical" />
                                    <a-button type="link" class="p-0" @click="Chart('images')">新增图片组</a-button>
                                    <a-divider type="vertical" />
                                    <a-button type="link" class="p-0" @click="Chart('line')">新增分割线</a-button>
                                    <a-divider type="vertical" />
                                </div>
                            </template>
                            <div class="itembox" :style="{ border: '1px dashed #CCC', textAlign: 'center' }">
                                + 点击新增元素
                            </div>
                        </a-popover>
                    </div>
                    <div :style="{ width: 'calc(100% - ' + form.width + 'px)' }">
                        <a-tabs v-model="rightactive" @change="callback">
                            <a-tab-pane key="1" tab="海报参数表单">
                                <a-form-model :form="form" ref="ruleForm" :model="form" :rules="rules"
                                    :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" size="small">
                                    <a-form-model-item label="操作">
                                        <a-button type="primary" key="2" @click="onSubmit" :loading="submitloading"
                                            :disabled="readonly">
                                            保存表单数据
                                        </a-button>
                                    </a-form-model-item>
                                    <a-form-model-item label="小程序可见状态" prop="mini_show">
                                        <a-radio-group v-model="form.mini_show">
                                            <a-radio value="1">
                                                正常可见
                                            </a-radio>
                                            <a-radio value="2">
                                                行程规划中（客户小程序不可见行程明细）
                                            </a-radio>
                                        </a-radio-group>
                                    </a-form-model-item>
                                    <a-form-model-item label="行程名称" prop="title">
                                        <a-input v-model="form.title" placeholder="请输入行程名称" />
                                    </a-form-model-item>
                                    <a-form-model-item label="预估出行时间">
                                        <a-range-picker v-model="planDate" :disabled-date="disabledDate"
                                            :disabled-time="disabledRangeTime" @change="changePlanDate"
                                            format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" />
                                    </a-form-model-item>
                                    <a-form-model-item label="行程所属人">
                                        <a-select v-model="form.user_id" style="width: 240px" placeholder="选择行程所属人"
                                            option-label-prop="label" :filter-option="filterOption" showSearch
                                            allowClear>
                                            <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id"
                                                :label="v.real_name">
                                                {{ v.real_name }}
                                                <span role="img" :aria-label="v.real_name"
                                                    style="font-size: 14px; color: #888">
                                                    ({{ v.department.department_name }})
                                                </span>
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                    <a-form-model-item label="客户备注记录">
                                        <p style="line-height: 24px;white-space: pre-line">{{ form.plan_msg }}</p>
                                    </a-form-model-item>
                                    <a-form-model-item label="虚线开关">
                                        <a-radio-group v-model="form.xuxian">
                                            <a-radio :value="true">
                                                开启
                                            </a-radio>
                                            <a-radio :value="false">
                                                关闭
                                            </a-radio>
                                        </a-radio-group>
                                    </a-form-model-item>
                                    <a-form-model-item label="对齐方式">
                                        <a-radio-group v-model="form.align">
                                            <a-radio value="left">
                                                左对齐
                                            </a-radio>
                                            <a-radio value="center">
                                                居中对齐
                                            </a-radio>
                                            <a-radio value="right">
                                                右对齐
                                            </a-radio>
                                        </a-radio-group>
                                    </a-form-model-item>
                                    <a-form-model-item label="画布宽带">
                                        <a-input-number v-model="form.width" :min="300" :max="600"
                                            style="width: 100%;" />
                                    </a-form-model-item>
                                    <a-form-model-item label="水印颜色">
                                        <el-color-picker v-model="form.fontColor"
                                            @change="changeOptions"></el-color-picker>
                                    </a-form-model-item>
                                    <a-form-model-item label="背景颜色">
                                        <el-color-picker v-model="form.backgroundColor"></el-color-picker>
                                    </a-form-model-item>
                                    <a-form-model-item label="图片素材尺寸">
                                        <a-input-number v-model="form.imageWidth" :step="1" :min="50" :max="800"
                                            style="width: 100%;" />
                                    </a-form-model-item>
                                    <a-form-model-item label="水印透明度">
                                        <a-slider v-model="form.globalAlpha" @afterChange="changeOptions" :min="0"
                                            :max="1" :step="0.1" />
                                    </a-form-model-item>
                                    <a-form-model-item label="水印文字大小">
                                        <a-input-number v-model="form.fontSize" :min="8" :max="36" :step="1"
                                            @blur="changeOptions" />
                                    </a-form-model-item>
                                    <a-form-model-item label="水印显示">
                                        <a-switch v-model="shuiyinswitch" @change="changeSuitch" />
                                    </a-form-model-item>
                                    <a-form-model-item label="水印文案">
                                        <a-input v-model="form.shuiyintext" placeholder="水印文案"
                                            @blur="changeOptions"></a-input>
                                    </a-form-model-item>
                                </a-form-model>
                            </a-tab-pane>
                            <a-tab-pane key="2" tab="行程修改记录">
                                <haibaolog ref="haibaolog" :haibaoid="form.haibaoid"></haibaolog>
                            </a-tab-pane>
                            <a-tab-pane key="3" tab="行程模板">
                                <muban ref="muban" :haibaoid="form.haibaoid" @usemodelok="usemodelok"
                                    :disabled="readonly">
                                </muban>
                            </a-tab-pane>
                            <a-tab-pane key="4" tab="客户心愿行程(新功能)">
                                <div v-for="(v, i) in favdata">
                                    <a-alert :message="`客户 ${v.create_time} 提交的心愿单项目`" type="info" />

                                    <a-list class="demo-loadmore-list" item-layout="horizontal" :data-source="v.items">
                                        <a-list-item slot="renderItem" slot-scope="item, index">
                                            <a-list-item-meta :description="item.subtitle">
                                                <a slot="title">{{ item.goods_name }}</a>
                                                <a-avatar slot="avatar" :src="item.goods_img" />
                                            </a-list-item-meta>
                                            <div slot="actions" style="text-align: right;">
                                                <div> <a>入选时价格：<b>{{ item.goods_price }}</b></a></div>
                                                <div>
                                                    <a>选择数量：<b>{{ item.count }}</b></a>
                                                    <!-- <a v-if="item.unit">/{{ item.unit }}</a> -->
                                                </div>
                                            </div>
                                        </a-list-item>
                                    </a-list>
                                </div>
                            </a-tab-pane>
                        </a-tabs>

                    </div>
                </div>
            </a-checkbox-group>
        </a-spin>
        <input type="file" id="imageInput" @change="changefile" hidden accept="image/*" />
    </a-card>
</template>
<script>
import draggable from "vuedraggable";
import { Watermark } from "watermark-js-plus";
import html2canvas from "html2canvas";
import "element-ui/lib/theme-chalk/index.css";
import haibaolog from "./haibaolog.vue";
import muban from "./muban.vue";
import moment from 'moment'
export default {
    components: { draggable, haibaolog, muban },
    data() {
        return {
            readonly: true,
            checkkey: "1",
            delarr: [],
            contenteditable: true,
            rightactive: '1',
            submitloading: false,
            spinning: false,
            exportLoading: false,
            customer_id: "",
            shuiyinswitch: true,
            planDate: [],
            form: {
                haibaoid: '',
                plan_start: '',
                plan_end: '',
                width: 500,
                imageWidth: 100,
                // title: moment().format('YYYY-MM-DD HH:mm:ss') + '规划行程',
                title: '',
                xuxian: true,
                watermark: null,
                shuiyintext: "彬总顶奢旅游俱乐部",
                fontColor: '#FFA500',
                backgroundColor: '#e7f5fe',
                align: 'center',
                globalAlpha: 0.5,
                fontSize: 14,
                user_id: undefined,
                mini_show: '1'
            },
            rules: {
                title: [
                    { required: true, message: '行程规划名称不能为空', trigger: 'blur' },
                ],
            },
            DataList: [
                // {
                //     type: 'text',
                //     value: '文案标题1'
                // },
                // {
                //     type: 'text',
                //     value: '文案标题2(出行日期:XX月XX日-XX月XX日)'
                // },
                // {
                //     type: 'images',
                //     value: []
                // },
                // {
                //     type: 'line'
                // }
            ],
            imageIndex: null,
            beishu: 2,
            userinfo: {},
            customerinfo: {},
            create_time: "",
            favdata: [],
            userList: []
        }
    },
    mounted() {
        const index = this.$store.state.buttonPower.findIndex(
            (item) => item == 'admin:haibao:update'
        );
        if (index > -1) {
            this.readonly = false
        }
        if (this.$route.query.rn == 1) {
            this.readonly = true
        }
        this.watermark = new Watermark();
        this.changeOptions()
        this.watermark.create()
        console.log(this.$route.query)
        this.form.haibaoid = this.$route.query.haibaoid
        this.getinfo()
        // 监听键盘按下事件
        window.addEventListener("keydown", this.handleKeyDown);
        // 监听键盘松开事件
        window.addEventListener("keyup", this.handleKeyUp);
        this.getUserList();
    },
    beforeDestroy() {
        // 组件销毁时移除监听
        window.removeEventListener("keydown", this.handleKeyDown);
        window.removeEventListener("keyup", this.handleKeyUp);
    },
    methods: {
        moment,
        noticeHandle() {
            this.$confirm({
                title: '是否通知会员行程规划已完成?',
                content: (
                    <div>
                        <p style="margin: 0">此方式，只针对在小程序中提交过心愿单且订阅了消息了的会员。</p>
                        <span style="color: red;">ps： 此方式属于微信一次性订阅消息，成功推送一次后，下次将无法推送，直到下次用户再提交一次心愿单</span>
                    </div>

                ),
                onOk: () => {
                    this.$http({
                        url: '/admin/haibao/notice',
                        method: 'post',
                        data: {
                            haibaoid: this.form.haibaoid
                        }
                    }).then(res => {
                        this.$success({
                            title: res.message,
                            // JSX support
                            content: "",
                        });
                    })
                },
                onCancel() { },
            });
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        getUserList() {
            this.$http({
                url: "/admin/user/page?page=1&limit=200",
                method: "get",
            }).then((res) => {
                this.userList = res.data.result;
            });
        },
        changePlanDate(e) {
            if (e.length == 2) {
                this.form.plan_start = e[0];
                this.form.plan_end = e[1];
            } else {
                this.form.plan_start = "";
                this.form.plan_end = "";
            }
        },
        range(start, end) {
            const result = [];
            for (let i = start; i < end; i++) {
                result.push(i);
            }
            return result;
        },
        disabledDate(current) {
            // Can not select days before today and today
            return current && current < moment().endOf('day');
        },
        disabledRangeTime(_, type) {
            if (type === 'start') {
                return {
                    disabledHours: () => this.range(0, 60).splice(4, 20),
                    disabledMinutes: () => this.range(30, 60),
                    disabledSeconds: () => [55, 56],
                };
            }
            return {
                disabledHours: () => this.range(0, 60).splice(20, 4),
                disabledMinutes: () => this.range(0, 31),
                disabledSeconds: () => [55, 56],
            };
        },
        handleKeyDown(event) {
            console.log()
            if (event.code === "ShiftLeft") {
                this.contenteditable = false;
                console.log("ctrl键按下！");
            }
        },
        handleKeyUp(event) {
            if (event.code === "ShiftLeft") {
                this.contenteditable = true;
                console.log("ctrl键松开！");
            }
        },
        del() {
            this.$message.error("不允许删除")
        },
        handleDragStart(event) {
            if (this.contenteditable) {
                event.preventDefault(); // 禁止拖拽
            } else {
                event.stopPropagation(); // 允许拖拽
            }
        },
        handleKeydown(event) {
            // 允许 Ctrl+V 粘贴
            if (event.ctrlKey && event.key === 'v') return;

            // 阻止输入、删除、回车等按键
            if (!event.ctrlKey && !event.metaKey) {
                event.preventDefault();
            }
        },
        handlePaste(event, index) {
            event.preventDefault(); // 阻止粘贴文本进入
            const items = (event.clipboardData || event.originalEvent.clipboardData).items;
            let file = null
            for (let item of items) {
                if (item.type.indexOf("image") !== -1) {
                    const file_ = item.getAsFile();
                    file = file_
                    break;
                }
            }
            if (file) {
                this.imageIndex = index
                this.changefile(file)
            } else {
                this.$message.error("未读取到复制的图片")
            }
        },
        usemodelok() {
            this.rightactive = '1'
            this.getinfo()
        },
        callback(e) {
            if (e == 2) {
                this.$refs.haibaolog.query()
            }
        },
        onSubmit() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.submitloading = true
                    this.$http({
                        url: '/admin/haibao/update',
                        method: 'post',
                        data: {
                            ...this.form,
                            imagewidth: this.form.imageWidth,
                            backgroundcolor: this.form.backgroundColor,
                            waterfontcolor: this.form.fontColor,
                            waterfontsize: this.form.fontSize,
                            xuxian: this.form.xuxian ? 1 : 0,
                            globalalpha: this.form.globalAlpha
                        }
                    }).then(() => {
                        this.$message.success("保存参数表单成功")
                    }).finally(() => this.submitloading = false)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //详情
        getinfo() {
            this.spinning = true
            this.$http({
                url: '/admin/haibao/info',
                method: 'post',
                data: {
                    id: this.form.haibaoid
                }
            }).then(res => {
                this.userinfo = res.data.userinfo
                this.customerinfo = res.data.customerinfo
                this.create_time = res.data.create_time
                this.form = {
                    ...res.data,
                    imageWidth: res.data.imagewidth,
                    backgroundColor: res.data.backgroundcolor,
                    fontColor: res.data.waterfontcolor,
                    fontSize: res.data.waterfontsize,
                    xuxian: res.data.xuxian == 1 ? true : false,
                    globalAlpha: res.data.globalalpha,
                    user_id: res.data.user_id || undefined,
                }
                this.planDate = res.data.plan_start ? [res.data.plan_start, res.data.plan_end] : []
                this.DataList = res.data.haibaoChildren.map(v => {
                    if (v.type == 'images') {
                        v.value = v.value ? v.value.split(',') : []
                    }
                    return v
                })
                const groupedData = this.groupByCreateTime(res.data.favdata)
                // 如果需要转换为数组形式
                this.favdata = Object.entries(groupedData).map(([create_time, items]) => ({
                    create_time,
                    items
                }));
                this.changeOptions()
                this.checkkey = new Date().getTime() + ''
            }).finally(() => this.spinning = false)
        },

        groupByCreateTime(data) {
            return data.reduce((groups, item) => {
                const createTime = item.create_time;
                if (!groups[createTime]) {
                    groups[createTime] = [];
                }
                groups[createTime].push(item);
                return groups;
            }, {});
        },
        // 阻止默认行为，使文件可以拖拽进来
        onDragOver(event) {
            event.preventDefault();
        },
        // 处理文件拖放
        onDrop(event) {
            if (!event) return
            const isJpgOrPng = event.file.type === 'image/jpeg' || event.file.type === 'image/png' || event.file.type === 'image/jpg';
            if (!isJpgOrPng) {
                return this.$message.error('只能上传图片文件!');
            }
            this.imageIndex = event.data.imageIndex
            const droppedFiles = event.file;
            // this.handleFiles(droppedFiles);
            this.changefile(droppedFiles)
        },
        onEnd(e) {
            // console.log(e.newIndex)
            // const newIndex = e.newIndex
            let items = []
            for (let i = 0; i < this.DataList.length; i++) {
                // if (i >= newIndex) {
                this.DataList[i].sort = i
                items.push({
                    haibaoitemid: this.DataList[i].haibaoitemid,
                    sort: i
                })
                // }
            }
            this.spinning = true
            this.$http({
                url: '/admin/haibaoitem/sort',
                method: "post",
                data: { items: items }
            }).then(() => {
                this.$message.success("数据已保存")
            }).finally(() => {
                this.spinning = false
            })
        },
        onEnd2(e, value) {
            console.log(value)
            this.spinning = true
            this.$http({
                url: '/admin/haibaoitem/update',
                method: 'post',
                data: {
                    ...value
                }
            }).then(() => {
                this.$message.success("数据已保存")
            }).finally(() => this.spinning = false)
        },
        changeSuitch(e) {
            if (e) {
                this.watermark.create();
            } else {
                this.watermark.destroy()
            }
        },
        changeOptions() {
            this.watermark.changeOptions({
                content: this.form.shuiyintext,
                fontSize: this.form.fontSize + "px",
                globalAlpha: this.form.globalAlpha,
                width: 150,
                height: 150,
                translateX: 10,
                fontColor: this.form.fontColor,
                parent: ".haibaoContainer",
            })
        },
        uploadimg(imageIndex) {
            this.imageIndex = imageIndex
            document.getElementById('imageInput').click();
        },
        changefile(file) {
            // const file = files[0];
            if (file) {
                // console.log("图片名称:", file);
                // const reader = new FileReader();
                // reader.onload = (e) => {
                //     // this.imageSrc = e.target.result;
                //     this.DataList[this.imageIndex].value.push(e.target.result)
                // };
                // reader.readAsDataURL(file);
                const formData = new FormData();
                formData.append('file', file);
                this.spinning = true
                this.$http({
                    url: '/admin/sys/upload',
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data', // 告诉服务器上传的是文件
                    },
                    data: formData
                }).then(res => {
                    this.DataList[this.imageIndex].value.push(res.data.url)
                    this.blurText('', this.imageIndex)
                })
            } else {
                console.log("未选择图片");
            }
            document.getElementById('imageInput').value = '';
        },
        delimg(i, imgindex) {
            this.imageIndex = i;
            this.DataList[i].value.splice(imgindex, 1)
            this.blurText('', this.imageIndex)
        },
        //新增元素
        Chart(type, i = "") {
            // this.onEnd({newIndex: ""})
            this.spinning = true
            const obj = { haibaoitemid: '', sort: i === "" ? this.DataList.length : i + 1, textcolor: "#000" }
            let add = type == 'line' ? { type: 'line', ...obj } : type == 'text' ? { type: 'text', value: '', ...obj } : { type: 'images', value: [], ...obj }
            this.$http({
                url: '/admin/haibaoitem/create',
                method: 'post',
                data: {
                    ...add,
                    haibaoid: this.form.haibaoid
                }
            }).then(res => {
                add.haibaoitemid = res.data.haibaoitemid
                if (i === "") {
                    this.DataList.push(add)
                } else {
                    this.DataList.splice((i + 1), 0, add)
                }
                this.onEnd()
            }).finally(() => this.spinning = false)
        },
        //文案输入失去焦点
        blurText(e, i) {
            const update = this.DataList[i]
            this.spinning = true
            this.$http({
                url: '/admin/haibaoitem/update',
                method: 'post',
                data: update
            }).then(() => {
                this.$message.success("数据已保存")
            }).finally(() => this.spinning = false)
        },
        //删除
        delChart(haibaoitemids, reset = false) {
            this.$confirm({
                title: '是否删除选中的元素?',
                content: '二次确认～',
                onOk: () => {
                    this.spinning = true
                    this.$http({
                        url: '/admin/haibaoitem/delete',
                        method: 'post',
                        data: {
                            haibaoitemids: haibaoitemids
                        }
                    }).then(() => {
                        if (reset) this.delarr = []
                        this.$message.success("删除成功")
                        this.getinfo()
                    }).catch(() => this.spinning = false)
                },
            });
        },
        //导出为图片
        exportImage() {
            this.exportLoading = true
            setTimeout(async () => {
                const element = this.$refs.captureArea;
                // 使用 html2canvas 将 DOM 转换为图片
                const canvas = await html2canvas(element, {
                    useCORS: true,// 启用跨域支持
                    dpi: 300, // 解决生产图片模糊
                    scale: parseFloat(this.beishu), // 放大倍数，生成更高分辨率的图片
                    backgroundColor: null, // 设置背景为透明
                });
                const imageDataUrl = canvas.toDataURL("image/png");
                // 下载图片
                const link = document.createElement("a");
                link.href = imageDataUrl;
                link.download = "capture_with_watermark.png";
                link.click();
                this.exportLoading = false
            }, 500);
        }
    }
}
</script>
<style scoped lang="scss">
.cardContainer {
    display: flex;
}

.shanchu {
    position: absolute;
    top: 4px;
}

.haibaoContainer {
    position: relative;
    // border: 1px solid #CCC;
    // background: #e7f5fe;
    min-height: calc(100vh - 110px);
    min-width: 300px;
    margin-right: 20px;
    padding: 40px 20px;
    box-sizing: border-box;

    .itembox {
        // border: 1px dashed #CCC;
        padding: 4px 0;
        margin: 4px 0;
        cursor: pointer;
    }

    .pbox {
        font-size: 16px;
        font-weight: bold;
        font-family: '微软雅黑';
        text-align: center;
        color: #000;
        white-space: pre-line;
    }

    .imagebox {
        display: flex;
        // justify-content: center;
        flex-wrap: wrap;

        .imgcontainer {
            width: 100px;
            height: 100px;
            background: #FFF;
            margin: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            cursor: pointer;
            position: relative;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .delimg {
                position: absolute;
                width: 25%;
                height: 25%;
                background: red;
                color: #FFF;
                right: 5%;
                top: 5%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 100%;
                font-weight: bold;
            }
        }
    }

    .line {
        .linevalue {
            margin: 10px 0;
            width: 100%;
            height: 1px;
            background: #e3e3e3;
        }
    }
}

.delarr {
    position: absolute;
    left: -18px;
    top: 0;
}
</style>